module.exports = __webpack_public_path__ + "static/media/planet-key.e621c7ac.png";